import store from "../../../store";
import { IBehaviorLocalhostConfiguration } from "../../../domain/configuration";
import { IImageClipboardService } from "../../../domain/localhost";
import { User } from "../../../domain/user";
import { ResponsibleUrlSchemeClient } from "./ResponsibleUrlSchemeClient";

interface IRegisterClippedImageRequest {
  userCode: string;
}

interface IRegisterClippedImageResponse {
  isOk: boolean;
  guid: string;
}

export class ImageClipboardService implements IImageClipboardService {
  constructor(private readonly _getToken: () => string, private readonly _configuration: IBehaviorLocalhostConfiguration) {}

  isAvailable(): boolean {
    return this._configuration.isEnable
        && this._configuration.clippedImageRegisterer.isEnable;
  }

  async registerClippedImage(): Promise<string> {
    const client = new ResponsibleUrlSchemeClient(this._getToken, this._configuration);
    const response = await client.request<IRegisterClippedImageRequest, IRegisterClippedImageResponse> (
      "registerClippedImage",
      {
        userCode: (store.getters.user as User).id,
      },
      this._configuration.clippedImageRegisterer.responseWaiting);
    if (response.isOk) {
      return response.guid as string;
    } else {
      throw new Error("Assistantからの結果がNGでした.");
    }
  }
}
